import { render, staticRenderFns } from "./group.vue?vue&type=template&id=56e79ea7&"
import script from "./group.vue?vue&type=script&lang=tsx&"
export * from "./group.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports